import React, {Fragment, PureComponent} from 'react';

import LandingCompanyUniverse from './LandingCompanyUniverse.jsx';

import headerImg from '../../../media/images/universes/purchase.jpg?size=600';
import legalImg from '../../../media/images/sub-universes/purchase/legal.jpg?size=600';
import purchaseImg from '../../../media/images/sub-universes/purchase/purchase.jpg?size=600';
import supplyChainImg from '../../../media/images/sub-universes/purchase/supplyChain.jpg?size=600';

const headerBrief = <Fragment>
  <p>
    Que vous recherchiez <strong>un expert, un renfort pour vos équipes ou un manager de transition Achats,
    approvisionnement et Supply</strong>, Twineeds est la plateforme qu'il vous faut.
  </p>
  <p>Accédez directement à nos consultants ou consultez nous directement avec votre recherche.</p>
</Fragment>;

const title = "Boostez vos équipes | Consultants experts | Achats & Supply";
const description = "Rencontrez des profils qualifiés de consultants achats et supply chain pour vos besoins en achats directs, indirects ou projets spécifiques. Rencontrons-nous.";

const ourJobsItems = [
  {
    title: 'Achats & approvisionnement',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour du monde des achats et ' +
      'approvisionnements; <strong>acheteurs, SRM, gestionnaires d\'ententes</strong> etc.</p><p>Tout types ' +
      'd\'<strong>achats indirects, hors production et TI</strong> (informatique). Fonction support achat et ' +
      'approvisionnement.</p>',
    img: purchaseImg.src,
    imgAlt: 'Poignée de main entre un consultant achats et un professionnel'
  },
  {
    title: 'Supply Chain',
    brief: '<p>Des profils pour <strong>renforcer vos équipes</strong> autour du monde de la Supply Chain : <strong>' +
      'logisticien, responsable transport, gestionnaire de flux, chef de projet supply chain</strong> etc.</p>' +
      '<p>Fonction support Supply</p>',
    img: supplyChainImg.src,
    imgAlt: 'Plateforme logistique dédiée au transport et à la gestion des flux dans la supply chain'
  },
  {
    title: 'Juridique et Gestion d\'entente',
    brief: '<p>Des profils de juristes pour <strong>renforcer vos équipes</strong> sur les problématiques ' +
      'spécifiques de l\'entreprise : <strong>droit des ententes, droit commercial, droit du travail, propriété ' +
      'intellectuelle</strong> etc.</p>',
    img: legalImg.src,
    imgalt: 'Signature d\'un contrat par un consultant RH'
  }
];

const specificDifference = <Fragment>
  <strong>Une large gamme de compétences sur les achats et la supply</strong>, quand les cabinets sont généralement
  spécialisés (achats de production ou les achats indirects).
</Fragment>;

export default class LandingCompanyPurchase extends PureComponent {
  render() {
    return <LandingCompanyUniverse
      headerBrief={headerBrief}
      headerImg={headerImg.src}
      headerImgAlt="Équipe concentrée sur un projet stratégique devant un PC"
      helmet={{title, description}}
      ourJobsItems={ourJobsItems}
      specificDifference={specificDifference}
      title="Besoin de spécialistes des Achats et approvisionnements ou de la Supply Chain ?"
      universeCode="purchase"
    />;
  }
}
